// src/components/PanjatPinangVisual.js
import React from 'react';

// =====================================================================
// PERBAIKAN UTAMA #1:
// Pastikan SEMUA gambar yang digunakan di dalam komponen ini DIIMPOR di sini.
// Error terjadi karena `poleImage` tidak diimpor.
// =====================================================================
import poleImage from '../assets/pole.png'; // <-- BARIS INI KEMUNGKINAN BESAR HILANG
import climberLeftStandImage from '../assets/climber-left-stand.png';
import climberLeftClimbImage from '../assets/climber-left-climb.png';
import climberRightStandImage from '../assets/climber-right-stand.png';
import climberRightClimbImage from '../assets/climber-right-climb.png';

// --- Konfigurasi Statis Game Panjat Pinang ---
const WINNING_SCORE = 7;
const MAX_CLIMB_HEIGHT_PERCENT = 75;

/**
 * Komponen PanjatPinangVisual yang sudah diperbaiki.
 * @param {object} props
 * @param {number} props.leftScore - Skor pemain kiri.
 * @param {number} props.rightScore - Skor pemain kanan.
 */
function PanjatPinangVisual({ leftScore, rightScore }) {
    
    const calculateClimbHeight = (score) => {
        const effectiveScore = Math.min(score, WINNING_SCORE);
        const progress = effectiveScore / WINNING_SCORE;
        return progress * MAX_CLIMB_HEIGHT_PERCENT;
    };

    const leftHeightPercent = calculateClimbHeight(leftScore);
    const rightHeightPercent = calculateClimbHeight(rightScore);

    return (
        <div className="game-field panjat-pinang-field">
            {/* --- Tiang & Pemanjat KIRI --- */}
            <div className="pole-container left-pole">
                {/* `poleImage` sekarang sudah terdefinisi karena ada `import` di atas */}
                <img src={poleImage} alt="Tiang Pinang" className="pole-image" />
                <div 
                    className="climber-container left-climber" 
                    style={{ bottom: `${leftHeightPercent}%` }}
                >
                    <img 
                        src={climberLeftStandImage} 
                        alt="Pemain Kiri Berdiri" 
                        className="climber-image stand" 
                        style={{ display: leftScore > 0 ? 'none' : 'block' }} 
                    />
                    <img 
                        src={climberLeftClimbImage} 
                        alt="Pemain Kiri Memanjat" 
                        className="climber-image climb" 
                        style={{ display: leftScore > 0 ? 'block' : 'none' }} 
                    />
                </div>
            </div>

            {/* --- Tiang & Pemanjat KANAN --- */}
            <div className="pole-container right-pole">
                <img src={poleImage} alt="Tiang Pinang" className="pole-image" />
                <div 
                    className="climber-container right-climber" 
                    style={{ bottom: `${rightHeightPercent}%` }}
                >
                    <img 
                        src={climberRightStandImage} 
                        alt="Pemain Kanan Berdiri" 
                        className="climber-image stand" 
                        style={{ display: rightScore > 0 ? 'none' : 'block' }} 
                    />
                    <img 
                        src={climberRightClimbImage} 
                        alt="Pemain Kanan Memanjat" 
                        className="climber-image climb" 
                        style={{ display: rightScore > 0 ? 'block' : 'none' }} 
                    />
                </div>
            </div>
        </div>
    );
}

export default PanjatPinangVisual;